import(/* webpackMode: "eager", webpackExports: ["default"] */ "/hisea-ssr/src/components/ReferAFriend/index.js");
